const BUILDING_SYNONYMS = [
  'Building',
  'Crafting',
  'Spinning up',
  'Assembling',
  'Provisioning',
  'Constructing',
  'Forging',
  'Booting',
  'Staging',
  'Cooking up',
  'Wiring up',
  'Laying the foundation for',
];

/**
 * @param {string|null|undefined} exclude
 * @returns {string}
 */
export function pickBuildingSynonym(exclude) {
  const pool = exclude
    ? BUILDING_SYNONYMS.filter((word) => word !== exclude)
    : BUILDING_SYNONYMS;
  return pool[Math.floor(Math.random() * pool.length)];
}
